import { RouteParam } from "../../../routes";
import { MODULE, ACTION } from "../../../utils/enums";
import { urls } from "../../../utils/urls";
import payment_request_routes from "../../purchase_order/routers/payment_request_routes";
import project_routes from "../../purchase_order/routers/project_routes";
import PurchaseOrderCreateScreen from "../purchase_order_create/purchase_order_create";
import PurchaseOrderListScreen from "../purchase_order_list/purchase_order_list";

const prev_purchase_order_routes: RouteParam[] = [
  {
    isPrivate: true,
    fullScreen: false,
    exact: true,
    path: urls.purchase_order_prev,
    component: PurchaseOrderListScreen,
    module: MODULE.purchase_order,
    main_module: MODULE.procurement_panel,
    action: [ACTION.CREATE, ACTION.READ, ACTION.UPDATE],
    operator: "or",
  },
  {
    isPrivate: true,
    fullScreen: false,
    exact: true,
    path: urls.purchase_order_prev + "/create",
    component: PurchaseOrderCreateScreen,
    module: MODULE.purchase_order,
    main_module: MODULE.procurement_panel,
    action: [ACTION.CREATE, ACTION.READ, ACTION.UPDATE],
    operator: "or",
  },
  {
    isPrivate: true,
    fullScreen: false,
    exact: true,
    path: urls.purchase_order_prev + "/update/:id",
    component: PurchaseOrderCreateScreen,
    module: MODULE.purchase_order,
    main_module: MODULE.procurement_panel,
    action: [ACTION.CREATE, ACTION.READ, ACTION.UPDATE],
    operator: "or",
  },
  //   {
  //     isPrivate: true,
  //     fullScreen: false,
  //     exact: true,
  //     path: urls.purchase_order + "/approval",
  //     component: PurchaseOrderApprovalListScreen,
  //     module: MODULE.purchase_order_approval,
  //     main_module: MODULE.procurement_panel,
  //     action: [ACTION.CREATE, ACTION.READ, ACTION.UPDATE],
  //     operator: "or",
  //   },
  //   {
  //     isPrivate: true,
  //     fullScreen: false,
  //     exact: true,
  //     path: urls.purchase_order + "/approval/:id",
  //     component: PurchaseOrderApprovalScreen,
  //     module: MODULE.purchase_order_approval,
  //     main_module: MODULE.procurement_panel,
  //     action: [ACTION.CREATE, ACTION.READ, ACTION.UPDATE],
  //     operator: "or",
  //   },
  ...project_routes,
  ...payment_request_routes,
];

export default prev_purchase_order_routes;
